<template>
    <v-navigation-drawer
        :value="value"
        class="module-nav-drawer"
        fixed
        temporary
        color="white"
        width="340"
        @input="$emit('input', $event)"
    >
        <div class="module-nav-header">
            <div class="module-nav-brand-icon" aria-hidden="true">
                <v-icon color="grey darken-2">{{ brandIcon }}</v-icon>
            </div>
            <div class="module-nav-heading">
                <span class="module-nav-eyebrow">Merus</span>
                <span class="module-nav-title">{{ title }}</span>
            </div>
            <v-btn
                icon
                class="module-nav-close"
                :aria-label="$t('button.close')"
                @click="$emit('input', false)"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
        <v-list class="module-nav-list" nav>
            <v-list-item
                v-for="(item, i) in items"
                :key="`MODULE-${i}`"
                :class="{ 'module-nav-item--active': isActive(item) }"
                :input-value="isActive(item)"
                color="grey darken-3"
                :aria-current="isActive(item) ? 'page' : null"
                class="module-nav-item"
                @click="onSelect(item)"
            >
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title v-text="item.text" />
                </v-list-item-content>
                <v-list-item-icon v-if="isActive(item)" class="module-nav-active-mark">
                    <v-icon small color="grey darken-3">mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import EventBus from '@/utils/eventBus';

export default {
    name: 'ModuleNavDrawer',
    props: {
        value: { type: Boolean, default: false },
        title: { type: String, required: true },
        brandIcon: { type: String, default: 'mdi-map-marker-path' },
        items: { type: Array, default: () => [] },
        activeValue: { default: null },
    },
    mounted() {
        EventBus.$on('module-nav-drawer-toggle', this.open);
    },
    beforeDestroy() {
        EventBus.$off('module-nav-drawer-toggle', this.open);
    },
    methods: {
        isActive(item) {
            return item && this.activeValue === item.value;
        },
        open() {
            this.$emit('input', true);
        },
        onSelect(item) {
            this.$emit('input', false);
            this.$emit('select', item);
        },
    },
};
</script>

<style>
.module-nav-drawer {
    position: fixed !important;
    top: 0 !important;
    bottom: 0 !important;
    height: 100vh !important;
    width: min(400px, calc(100vw - 24px)) !important;
    z-index: 1200 !important;
    background: #fff !important;
}
.module-nav-drawer .v-navigation-drawer__content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}
.module-nav-header {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 14px;
    min-height: 112px;
    padding: 24px 16px 20px 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    background: #fff;
}
.module-nav-brand-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 46px;
    width: 46px;
    height: 46px;
    border-radius: 4px;
}
.module-nav-heading {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-width: 0;
}
.module-nav-eyebrow {
    color: rgba(0, 0, 0, 0.54);
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    line-height: 1.2;
    text-transform: uppercase;
}
.module-nav-title {
    margin-top: 3px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.87);
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 1.3;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.module-nav-close {
    flex: 0 0 auto;
    color: rgba(0, 0, 0, 0.54) !important;
}
.module-nav-list {
    padding: 0 !important;
    background: transparent !important;
}
.module-nav-item {
    min-height: 48px;
    margin-bottom: 6px;
    border-radius: 4px !important;
    color: rgba(0, 0, 0, 0.72) !important;
    transition: background-color 0.18s ease, color 0.18s ease;
}
.module-nav-item:hover {
    background: rgba(0, 0, 0, 0.04) !important;
}
.module-nav-item--active {
    background: rgba(0, 0, 0, 0.08) !important;
    color: rgba(0, 0, 0, 0.87) !important;
    font-weight: 600;
}
.module-nav-item .v-list-item__icon {
    margin-right: 16px;
    color: inherit;
}
.module-nav-item--active > .v-list-item__icon:first-child {
    color: rgba(0, 0, 0, 0.78);
}
.module-nav-active-mark.v-list-item__icon {
    min-width: auto;
    margin-right: 0;
    margin-left: 8px;
}
</style>
